<section *ngIf="!hasActivityStatus" class="activity">
    <hero-banner (addonsScrollAction)="onAddonsScrollAction($event)" [isMemberViewer]="isMemberViewer" [isPrimary]="isPrimary"></hero-banner>
    <xm-segment-switch-banner *ngIf="showSegmentSwitchBanner"
        [pageData]="cmsSegmentSwitch"></xm-segment-switch-banner>
    <xm-display-card class="my-data" id="my-data">
        <div class="my-data-header">
            <h2 class="data-header">{{ cmsLineData.header }}</h2>
            <a *ngIf="canAddLines && (isPrimary || isManager)" class="xm-btn-link-light add-line" [href]="getShopUrl()">
                <xm-media-image [imageOptions]="addLineIconOptions" class="add-line-icon" size="height">
                </xm-media-image>
                <span class="label">{{ cmsLineData.addLineLabel }}</span>
            </a>
        </div>
        <div *ngFor="let plan of plans; let index = index; let last=last" class="plan" [ngClass]="{'last-plan': last}">
            <div *ngIf="(!accountSummary?.level6Customer && !accountSummary?.level5Customer && !isNoLevel) || (accountSummary?.level5Customer && !plan.isUnlimited)">
                <p class="no-activate-line-warning" *ngIf="plan.isByTheGigShared && plan.allLinesPending">{{
                    cmsLineData.noActiveLineWarning }}</p>
                <div class="plan-header" *ngIf="!(isBusinessUser && plan.isTablet)">
                    <div class="wrapper">
                        <div class="header">
                            <h3>{{ getPlanHeader(plan) }}</h3>
                            <p *ngIf="plan.isByTheGig || plan.isByTheGigShared">{{ plan.dataUsage | convertUnit: {
                                methodName:'mbToGb' } }} GB Used</p>
                        </div>
                        <button *ngIf="plan.isByTheGigShared && !isSeg5"
                            [disabled]="isMemberViewer"
                            [promiseBtn]="planEligibilityPromise" (promiseClick)="openSwitchDataModal()"
                            class="change-plan-button-desktop xm-btn-secondary-light promise-btn"
                            [ngClass]="{'disabled': isMemberViewer}"><span>{{
                                cmsLineData.changePlanButton }}</span>
                        </button>
                    </div>
                    <data-graph *ngIf="plan.isByTheGig" [dataUsage]="plan.dataUsage" aria-hidden="true"></data-graph>
                    <overage-graph *ngIf="plan.isByTheGigShared && !isSeg5" [dataUsage]="plan.dataUsage"
                        [dataPassSize]="plan.dataPassSize" [overage]="plan.dataOverage">
                    </overage-graph>
                    <button id="switch-plan" *ngIf="plan.isByTheGigShared && !isSeg5"
                        [disabled]="isMemberViewer"
                        [promiseBtn]="planEligibilityPromise"
                        (promiseClick)="openSwitchDataModal()"
                        class="change-plan-button-mobile xm-btn-secondary-light promise-btn"
                        [ngClass]="{'disabled': isMemberViewer}"><span>{{
                            cmsLineData.changePlanButton }}</span>
                    </button>
                </div>
                <div class="promotions-banner-section" *ngIf="enableIcopPhaseOnePlanSwitch && promotionsBanner && (plan.isByTheGig || plan.isByTheGigShared)">
                    <div class="promotions-banner">
                        <xm-media-image [imageOptions]="infoIconGrey" size="width" center="vert"
                                class="icon"></xm-media-image>
                        <div class="promotions-content">{{ promotionsBanner?.body}}</div>
                    </div>
                </div>
                <ng-container *ngIf="isBusinessUser;else showAllLines">
                    <div *ngIf="index === 0 && showSortFilter">
                        <label class="sort-label" id="sort-dropdown">{{ cmsLineData.sortByLabel }}</label>
                        <xm-dropdown [optionsList]="cmsLineData.sortByOptions" [scrollHeight]="'300px'"
                            [ariaLabelId]="'label-id'" (onCollapse)="dropDownChange($event)">
                        </xm-dropdown>
                    </div>
                    <div class="unlimited-plan" *ngIf="isBusinessUser && plan.isTablet">
                        <div class="plan-header">
                            <div class="wrapper">
                                <div class="header">
                                    <h3>{{ getPlanHeader(plan) }}</h3>
                                </div>
                            </div>
                        </div>
                        <div class="plan-subgroup unlimited-intro" *ngIf="plan.unlIntroLines.length > 0">
                            <p class="plan-subgroup-header">{{ getUnlimitedPlanName(plan.unlIntroLines) }}</p>
                            <ng-container *ngIf="isBusinessUser; else showAllLines" class="lines-container">
                                <div *ngIf="index === 0 && showSortFilter">
                                    <label class="sort-label" id="sort-dropdown">{{ cmsLineData.sortByLabel }}</label>
                                    <xm-dropdown [optionsList]="cmsLineData.sortByOptions" [scrollHeight]="'300px'"
                                        [ariaLabelId]="'label-id'" (onCollapse)="dropDownChange($event)">
                                    </xm-dropdown>
                                </div>
                                <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard"
                                    [plan]="plan" *ngFor="let lineCard of getIntroLinesList(plan)"></line-card>
                                <button *ngIf="plan.unlIntroLines.length > initialLoadLimit"
                                    (click)="toggleLineList(plan)" class="xm-btn-secondary-light show-more-button">{{
                                    getShowLinesLabel(plan, UnlPlanSubgroup.BASIC) }}</button>
                            </ng-container>
                            <ng-template #showAllLines class="lines-container">
                                <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard"
                                    [plan]="plan" *ngFor="let lineCard of plan.unlIntroLines"></line-card>
                            </ng-template>
                        </div>
                        <div class="plan-subgroup unlimited-premium" *ngIf="plan.unlPremiumLines.length > 0">
                            <p class="plan-subgroup-header">{{ getUnlimitedPlanName(plan.unlPremiumLines) }}</p>
                            <ng-container *ngIf="isBusinessUser; else showAllLines">
                                <div *ngIf="index === 0 && showSortFilter">
                                    <label class="sort-label" id="sort-dropdown">{{ cmsLineData.sortByLabel }}</label>
                                    <xm-dropdown [optionsList]="cmsLineData.sortByOptions" [scrollHeight]="'300px'"
                                        [ariaLabelId]="'label-id'" (onCollapse)="dropDownChange($event)">
                                    </xm-dropdown>
                                </div>
                                <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard"
                                    [plan]="plan" *ngFor="let lineCard of getPremiumLinesList(plan)"></line-card>
                                <button *ngIf="plan.unlPremiumLines.length > initialLoadLimit"
                                    (click)="toggleLineList(plan)" class="xm-btn-secondary-light show-more-button">{{
                                    getShowLinesLabel(plan, UnlPlanSubgroup.PREMIUM) }}</button>
                            </ng-container>
                            <ng-template #showAllLines>
                                <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard"
                                    [plan]="plan" *ngFor="let lineCard of plan.unlPremiumLines"></line-card>
                            </ng-template>
                        </div>
                    </div>
                    <div *ngIf="isBusinessUser && !plan.isTablet">
                        <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard"
                            [plan]="plan" *ngFor="let lineCard of getLinesList(plan)"></line-card>
                    </div>
                    <button *ngIf="plan.lines.length > initialLoadLimit" (click)="toggleLineList(plan)"
                        class="xm-btn-secondary-light show-more-button">{{ getShowLinesLabel(plan) }}</button>
                </ng-container>
                <ng-template #showAllLines>
                    <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard" [plan]="plan"
                        *ngFor="let lineCard of plan.lines"></line-card>
                </ng-template>
            </div>
            <div *ngIf="accountSummary?.level6Customer" class="unlimited-plan">
                <div class="plan-header">
                    <div class="wrapper"><div class="header"><h3>{{ getPlanHeader(plan) }}</h3></div></div>
                </div>
                <ng-container *ngIf="plan?.isUnlimited; else showAllLines">
                    <div class="plan-subgroup unlimited-select" *ngIf="plan.unlSelectLines.length > 0">
                        <p class="plan-subgroup-header">{{ getUnlimitedPlanName(plan.unlSelectLines) }}</p>
                        <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard"
                            [plan]="plan" *ngFor="let lineCard of plan.unlSelectLines"></line-card>
                    </div>
                    <div class="plan-subgroup unlimited-plus" *ngIf="plan.unlPlusLines.length > 0">
                        <p class="plan-subgroup-header">{{ getUnlimitedPlanName(plan.unlPlusLines) }}</p>
                        <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard"
                            [plan]="plan" *ngFor="let lineCard of plan.unlPlusLines"></line-card>
                    </div>
                </ng-container>
                <ng-template #showAllLines class="lines-container">
                    <div class="plan-subgroup">
                        <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard" [plan]="plan"
                            *ngFor="let lineCard of plan.lines"></line-card>
                    </div>
                </ng-template>
            </div>
            <div *ngIf="accountSummary?.level5Customer && plan.isUnlimited" class="unlimited-plan">
                <div class="plan-header">
                    <div class="wrapper">
                        <div class="header">
                            <h3>{{ getPlanHeader(plan) }}</h3>
                        </div>
                    </div>
                </div>
                <div class="plan-subgroup unlimited-intro" *ngIf="plan.unlIntroLines.length > 0">
                    <p class="plan-subgroup-header">{{ getUnlimitedPlanName(plan.unlIntroLines) }}</p>
                    <ng-container *ngIf="isBusinessUser;else showAllLines" class="lines-container">
                        <div *ngIf="index === 0 && showSortFilter">
                            <label class="sort-label" id="sort-dropdown">{{ cmsLineData.sortByLabel }}</label>
                            <xm-dropdown [optionsList]="cmsLineData.sortByOptions" [scrollHeight]="'300px'"
                                [ariaLabelId]="'label-id'" (onCollapse)="dropDownChange($event)">
                            </xm-dropdown>
                        </div>
                        <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard"
                            [plan]="plan" *ngFor="let lineCard of getIntroLinesList(plan)"></line-card>
                        <button *ngIf="plan.unlIntroLines.length > initialLoadLimit" (click)="toggleLineList(plan)"
                            class="xm-btn-secondary-light show-more-button">{{ getShowLinesLabel(plan,
                            UnlPlanSubgroup.BASIC) }}</button>
                    </ng-container>
                    <ng-template #showAllLines class="lines-container">
                        <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard"
                            [plan]="plan" *ngFor="let lineCard of plan.unlIntroLines"></line-card>
                    </ng-template>
                </div>
                <div class="plan-subgroup unlimited-plus" *ngIf="plan.unlPlusLines.length > 0">
                    <p class="plan-subgroup-header">{{ getUnlimitedPlanName(plan.unlPlusLines) }}</p>
                    <ng-container *ngIf="isBusinessUser; else showAllLines">
                        <div *ngIf="index === 0 && showSortFilter">
                            <label class="sort-label" id="sort-dropdown">{{ cmsLineData.sortByLabel }}</label>
                            <xm-dropdown [optionsList]="cmsLineData.sortByOptions" [scrollHeight]="'300px'"
                                [ariaLabelId]="'label-id'" (onCollapse)="dropDownChange($event)">
                            </xm-dropdown>
                        </div>
                        <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard"
                            [plan]="plan" *ngFor="let lineCard of getPlusLinesList(plan)"></line-card>
                        <button *ngIf="plan.unlPlusLines.length > initialLoadLimit" (click)="toggleLineList(plan)"
                            class="xm-btn-secondary-light show-more-button">{{ getShowLinesLabel(plan,
                            UnlPlanSubgroup.PLUS) }}</button>
                    </ng-container>
                    <ng-template #showAllLines>
                        <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard"
                            [plan]="plan" *ngFor="let lineCard of plan.unlPlusLines"></line-card>
                    </ng-template>
                </div>
                <div class="plan-subgroup unlimited-premium" *ngIf="plan.unlPremiumLines.length > 0">
                    <p class="plan-subgroup-header">{{ getUnlimitedPlanName(plan.unlPremiumLines) }}</p>
                    <ng-container *ngIf="isBusinessUser; else showAllLines">
                        <div *ngIf="index === 0 && showSortFilter">
                            <label class="sort-label" id="sort-dropdown">{{ cmsLineData.sortByLabel }}</label>
                            <xm-dropdown [optionsList]="cmsLineData.sortByOptions" [scrollHeight]="'300px'"
                                [ariaLabelId]="'label-id'" (onCollapse)="dropDownChange($event)">
                            </xm-dropdown>
                        </div>
                        <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard"
                            [plan]="plan" *ngFor="let lineCard of getPremiumLinesList(plan)"></line-card>
                        <button *ngIf="plan.unlPremiumLines.length > initialLoadLimit" (click)="toggleLineList(plan)"
                            class="xm-btn-secondary-light show-more-button">{{ getShowLinesLabel(plan,
                            UnlPlanSubgroup.PREMIUM) }}</button>
                    </ng-container>
                    <ng-template #showAllLines>
                        <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard"
                            [plan]="plan" *ngFor="let lineCard of plan.unlPremiumLines"></line-card>
                    </ng-template>
                </div>
            </div>
            <div *ngIf="enableCbmNoLevel && plan.isUnlimited" class="unlimited-plan">
                <div class="plan-header">
                    <div class="wrapper">
                        <div class="header">
                            <h3>{{ getPlanHeader(plan) }}</h3>
                        </div>
                    </div>
                </div>
                <div class="plan-subgroup unlimited-intro" *ngIf="plan.unlStandardLines.length > 0">
                    <p class="plan-subgroup-header">{{ getUnlimitedPlanName(plan.unlStandardLines) }}</p>
                    <ng-container *ngIf="isBusinessUser;else showAllLines" class="lines-container">
                        <div *ngIf="index === 0 && showSortFilter">
                            <label class="sort-label" id="sort-dropdown">{{ cmsLineData.sortByLabel }}</label>
                            <xm-dropdown [optionsList]="cmsLineData.sortByOptions" [scrollHeight]="'300px'"
                                [ariaLabelId]="'label-id'" (onCollapse)="dropDownChange($event)">
                            </xm-dropdown>
                        </div>
                        <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard"
                            [plan]="plan" *ngFor="let lineCard of getStandardLinesList(plan)"></line-card>
                        <button *ngIf="plan.unlStandardLines.length > initialLoadLimit" (click)="toggleLineList(plan)"
                            class="xm-btn-secondary-light show-more-button">{{ getShowLinesLabel(plan,
                            UnlPlanSubgroup.STANDARD) }}</button>
                    </ng-container>
                    <ng-template #showAllLines class="lines-container">
                        <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard"
                            [plan]="plan" *ngFor="let lineCard of plan.unlStandardLines"></line-card>
                    </ng-template>
                </div>
                <div class="plan-subgroup unlimited-plus" *ngIf="plan.unlProLines.length > 0">
                    <p class="plan-subgroup-header">{{ getUnlimitedPlanName(plan.unlProLines) }}</p>
                    <ng-container *ngIf="isBusinessUser; else showAllLines">
                        <div *ngIf="index === 0 && showSortFilter">
                            <label class="sort-label" id="sort-dropdown">{{ cmsLineData.sortByLabel }}</label>
                            <xm-dropdown [optionsList]="cmsLineData.sortByOptions" [scrollHeight]="'300px'"
                                [ariaLabelId]="'label-id'" (onCollapse)="dropDownChange($event)">
                            </xm-dropdown>
                        </div>
                        <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard"
                            [plan]="plan" *ngFor="let lineCard of getProLinesList(plan)"></line-card>
                        <button *ngIf="plan.unlProLines.length > initialLoadLimit" (click)="toggleLineList(plan)"
                            class="xm-btn-secondary-light show-more-button">{{ getShowLinesLabel(plan,
                            UnlPlanSubgroup.PRO) }}</button>
                    </ng-container>
                    <ng-template #showAllLines>
                        <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard"
                            [plan]="plan" *ngFor="let lineCard of plan.unlProLines"></line-card>
                    </ng-template>
                </div>
            </div>
            <div *ngIf="enableCbmNoLevel && !plan.isUnlimited" class="unlimited-plan">
                <div *ngIf="plan.isTablet">
                    <div class="plan-header">
                        <div class="wrapper">
                            <div class="header">
                                <h3>{{ getPlanHeader(plan) }}</h3>
                            </div>
                        </div>
                    </div>
                    <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard"
                            [plan]="plan" *ngFor="let lineCard of getLinesList(plan)"></line-card>
                    </div>
                <div *ngIf="!plan.isTablet">
                    <div class="plan-header">
                        <div class="wrapper">
                            <div class="header">
                                <h3>{{ getPlanHeader(plan) }}</h3>
                            </div>
                        </div>
                    </div>
                    <line-card class="line-card-item" [pageData]="cmslineCardData" [lineCard]="lineCard"
                            [plan]="plan" *ngFor="let lineCard of getLinesList(plan)"></line-card>
                    </div>
            </div>
        </div>
        <div class="manage-user-link" *ngIf="(isPrimary && (!isBusinessUser || enableLineLevelExperienceCBM))">
            <a class="xm-btn-link-light" rel="noopener" target="_blank" [href]="manageUserUrl">
                <span>{{ manageUserLink.text }}</span>
            </a>
        </div>
    </xm-display-card>
    <section class="activity">
        <xm-display-card *ngIf="!isGtpLoading" id="addons-section" class="my-data">
            <div class="my-data-header international-header">
                <h2 class="data-header">{{globalTravelPassHeader}}</h2>
            </div>
            <div *ngIf="enableCbmNoLevel" class="gemini-international">
                <xm-media-image aria-hidden="true" class="icon" [imageOptions]="globalTravelPassImage" size="auto"></xm-media-image>
                <div class="international-content">
                    <p class="subtitle">{{ geminiInternationalServices.subtitle }}</p>
                    <cms-text *ngIf="geminiInternationalServices.body" class="body" [originalText]="geminiInternationalServices.body"></cms-text>
                </div>
            </div>
            <div *ngIf="isSeg6ResiUser && isInternational && !enableCbmNoLevel">
                <xm-gtp-card [tab]="globalTab" [isInternational]="isInternational"
                    [mediaImageOptions]="globalTravelPassImage" [ctaLabel]="gtpCtaLabel" [inUseIcon]="inUseIcon" [isGtp]="true"
                    (searchTravelRatesClick)="onSearchTravelRatesBtnClick()">
                </xm-gtp-card>
            </div>
            <div *ngIf="!isInternational">
                <div class="gtp-tab-buttons" *ngIf="globalTab && mexCanTab">
                    <button *ngIf="globalTab" type="button" class="gtp-tab-btn" [ngClass]="{active: gtpTabName === 'GLOBAL'}"
                        (click)="gtpTabName = 'GLOBAL'">{{globalTab.passName}}</button>
                    <button *ngIf="mexCanTab" type="button" class="gtp-tab-btn" [ngClass]="{active: gtpTabName === 'MEXICO_CANADA'}"
                        (click)="gtpTabName = 'MEXICO_CANADA'">{{mexCanTab.passName}}</button>
                </div>
    
                <xm-gtp-card *ngIf="gtpTabName === 'GLOBAL' && globalTab" [tab]="globalTab" [mediaImageOptions]="globalTravelPassImage"
                    [ctaLabel]="gtpCtaLabel" [inUseIcon]="inUseIcon" [isGtp]="true" [displayPrice]="gtpPrice"
                    (addGlobalTravelPassClick)="onGtpCtaClick()" (searchTravelRatesClick)="onSearchTravelRatesBtnClick()"
                    (optionBtnClick)="onGtpOptionBtnClick($event)"></xm-gtp-card>
    
                <xm-gtp-card *ngIf="gtpTabName === 'MEXICO_CANADA' && mexCanTab" [tab]="mexCanTab" [mediaImageOptions]="mexicoCanadaImage"
                    [ctaLabel]="gtpCtaLabel" [inUseIcon]="inUseIcon" [isGtp]="false" [displayPrice]="mexCanPrice"
                    (addGlobalTravelPassClick)="onGtpCtaClick()"
                    (optionBtnClick)="onGtpOptionBtnClick($event)">
                </xm-gtp-card>
            </div>
        </xm-display-card>

        <xm-display-card *ngIf="isGtpLoading" class="my-data ghost-loader">
            <xm-loader-overlay type="gtpHeader"></xm-loader-overlay>
            <xm-loader-overlay type="banner"></xm-loader-overlay>
            <xm-loader-overlay type="gtpLine"></xm-loader-overlay>
        </xm-display-card>
    </section>

    <xm-current-cycle-banner *ngIf="!isMemberViewer" [pageData]="cmsCurrenctCycle" [transaction]="estimatedStatement"
        [isLoading]="isLoading"></xm-current-cycle-banner>
</section>
<section *ngIf="hasChangePending" class="activity">
    <xm-display-card class="plan-options">
        <div class="pending-image-container">
            <xm-media-image class="pending-image" [imageOptions]="changePendingIcon" center="auto" size="height">
            </xm-media-image>
        </div>
        <div class="pending-content">
            <p class="pending-header">{{ cmsChangePending.header }}</p>
            <p class="pending-description">{{ cmsChangePending.description }}</p>
            <p class="pending-subheader">{{ cmsChangePending.subhead }}</p>
            <cms-text *ngIf="!isMobile" class="pending-contact-option"
                [originalText]="changePendingCallText.callTextDesktop"></cms-text>
            <cms-text *ngIf="isMobile" class="pending-contact-option"
                [originalText]="changePendingCallText.callMobile"></cms-text>
            <cms-text *ngIf="isMobile" class="pending-contact-option"
                [originalText]="changePendingCallText.textMobile"></cms-text>
        </div>
    </xm-display-card>
</section>
<section *ngIf="hasAPIError" class="activity">
    <xm-display-card class="plan-options">
        <div class="pending-image-container">
            <xm-media-image class="pending-image" [imageOptions]="changePendingIcon" center="auto" size="height">
            </xm-media-image>
        </div>
        <div class="pending-content">
            <p class="pending-header">{{ errorBanner.header }}</p>
            <p class="pending-description">{{ errorBanner.description }}</p>
            <p class="pending-subheader">{{ errorBanner.subhead }}</p>
            <cms-text *ngIf="!isMobile" class="pending-contact-option"
                [originalText]="changePendingCallText.callTextDesktop"></cms-text>
            <cms-text *ngIf="isMobile" class="pending-contact-option"
                [originalText]="changePendingCallText.callMobile"></cms-text>
            <cms-text *ngIf="isMobile" class="pending-contact-option"
                [originalText]="changePendingCallText.textMobile"></cms-text>
        </div>
    </xm-display-card>
</section>
